import { faAngleRight, faAngleLeft } from '@fortawesome/pro-regular-svg-icons';

export const icons = [faAngleRight, faAngleLeft];
